import {AddRoadRounded} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const addresses = {
    id: 'addresses',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'addresses',
            title: 'Addresses',
            type: 'item',
            url: '/addresses',
            icon: AddRoadRounded,
            breadcrumbs: false,
            
        },
       
    ]
};

export default addresses;
